import React from 'react';
import { Box, BoxProps, Tooltip, Typography, styled } from '@mui/material';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { useTranslation } from 'react-i18next';

const Root = styled(Box)(({ theme }) => ({
    alignItems: 'center',
    color: theme.palette.text.secondary,
    display: 'flex',
    gap: theme.spacing(0.75),
}));

const StaticLabel = styled(Typography)({
    cursor: 'default',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

interface LocationStaffIndicatorProps extends Pick<BoxProps, 'sx'> {
    nameList: string[];
}

const LocationStaffIndicator: React.FC<LocationStaffIndicatorProps> = ({ nameList, sx }) => {
    const { t } = useTranslation('common');
    const count = nameList.length;

    const tooltipContent = count > 1 ? (
        <Box>
            {nameList.map((name, i) => (
                <Typography key={i} variant="body2">{name}</Typography>
            ))}
        </Box>
    ) : null;

    return (
        <Root sx={sx}>
            <PeopleAltOutlinedIcon fontSize="small" />
            {count === 0 && (
                <Typography variant="body2" noWrap>{t('no_staff_checked_in')}</Typography>
            )}
            {count === 1 && (
                <Typography variant="body2" noWrap>{t('staff_single_in_location', { name: nameList[0] })}</Typography>
            )}
            {count > 1 && (
                <Tooltip title={tooltipContent} arrow>
                    <StaticLabel variant="body2">
                        {t('staff_count_in_location', { count })}
                    </StaticLabel>
                </Tooltip>
            )}
        </Root>
    );
};

export default LocationStaffIndicator;
